import { Zap } from "lucide-react";
import { useSite, tx } from "@/lib/lang";
import { ui } from "@/lib/uiStrings";
import { Reveal, SectionLabel } from "./Reveal";

export default function Partners() {
  const { content, lang } = useSite();
  const partners = content.partners || [];
  const t = ui[lang];
  const doubled = [...partners, ...partners];

  return (
    <section id="partner" data-testid="partner-section" className="border-y border-ice/5 bg-surface/40 py-16 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 mb-10">
        <Reveal>
          <SectionLabel>{t.labels.partner}</SectionLabel>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl font-bold tracking-tight leading-snug text-ice">
            {tx(content.sezioni?.partners?.heading, lang) || t.partners.heading}
          </h2>
          <p className="mt-3 max-w-2xl text-sm text-muted-foreground">{tx(content.sezioni?.partners?.sub, lang) || t.partners.sub}</p>
        </Reveal>
      </div>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-onyx to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-onyx to-transparent z-10 pointer-events-none" />
        <div className="flex w-max animate-marquee" data-testid="partner-marquee">
          {doubled.map((p, i) => {
            const name = typeof p === "string" ? p : p.name;
            const role = typeof p === "string" ? null : p.role;
            return (
              <div key={i} className="flex items-start gap-10 px-10">
                <div className="group">
                  <span className="font-display text-2xl font-semibold text-ice/35 group-hover:text-azure transition-colors whitespace-nowrap">
                    {name}
                  </span>
                  {role && (
                    <span className="block text-xs text-muted-foreground/70 whitespace-nowrap mt-1">{role}</span>
                  )}
                </div>
                <Zap size={13} className="text-royal/60 shrink-0 mt-2.5" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
